import { render, staticRenderFns } from "./AuditsView.vue?vue&type=template&id=2ef1f48a&scoped=true&lang=pug"
import script from "./AuditsView.vue?vue&type=script&lang=ts"
export * from "./AuditsView.vue?vue&type=script&lang=ts"
import style0 from "./AuditsView.vue?vue&type=style&index=0&id=2ef1f48a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1f48a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef1f48a')) {
      api.createRecord('2ef1f48a', component.options)
    } else {
      api.reload('2ef1f48a', component.options)
    }
    module.hot.accept("./AuditsView.vue?vue&type=template&id=2ef1f48a&scoped=true&lang=pug", function () {
      api.rerender('2ef1f48a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Audits/AuditsView.vue"
export default component.exports